//import { useState, useEffect } from 'react';
import { useState } from 'react';
import SignupItem from "./SignupItem";
//import axios from 'axios';
import qs from 'qs';
import { getAirData } from '../helpers/Options';
import classes from './SignupList.module.css';
import SignupForm from './SignupForm';
import { useQuery } from '@tanstack/react-query';

function SignupList( props ) {
//	const [isLoading, setIsLoading] = useState(true);
//	const [theSignups, setLoadedMeetups] = useState([]);
	const [signupActive, setSignupState] = useState(false);
	const [sfProps, setSFProps] = useState({});
	const queryArgs = {action: 'SAS_handleAJAX', function: 'getUserSignups', email: props.email }
	const signups = useQuery({
		queryKey: ['signups'],
		queryFn: () => getAirData(qs.stringify({action: 'SAS_handleAJAX', function: 'getSignups' }))
	});
	useQuery({
		queryKey: ['signups', props.email],
		queryFn: () => getAirData(qs.stringify(queryArgs))
	});
	
	function closeForm() { setSignupState(false); }
	function showSignupForm(signupData) {
		setSFProps(signupData);
		setSignupState(true);
	}
	
	if (typeof signups.data === 'undefined') {
		return (
			<div>
				<div className={classes.listContainer}>
					<div className={classes.signupBlock}>...</div>
					<div className={classes.signupBlock}>...</div>
					<div className={classes.signupBlock}>...</div>
					<div className={classes.signupBlock}>...</div>
					<div className={classes.signupBlock}>...</div>
					<div className={classes.signupBlock}>...</div>
				</div>
			</div>
	); }
	
	//if (true) { return true; }
	return (
		<div>
			<div className={classes.listContainer}>
				{signups.data.map((signup) => (
					<SignupItem 
						key={signup.id}
						id={signup.id}
						activity={signup.fields.Activity}
						poster={signup.fields.Poster}
						text={signup.fields.ShortText}
						deadline={signup.fields.Deadline}
						expired={signup.fields.Expired}
						filled={signup.fields.Filled}
						remaining={signup.fields.Remaining}
						required={signup.fields.Required}
						status={signup.fields.Status}
						showSignupForm={showSignupForm}
						signup={signup}
						{...props}
						/>
					))}
			</div>

			{signupActive && <SignupForm {...sfProps} closeForm={closeForm} active={signupActive} {...props} />}
		</div>
	)	
}

export default SignupList;